// extracted by mini-css-extract-plugin
module.exports = {"modal":"PopUp_modal__25ZIc","fullModal":"PopUp_fullModal__29O9E","modalHeader":"PopUp_modalHeader__3kb1j"};